import * as React from "react";
import { Growl } from "primereact/growl";

export default class Growls extends React.Component {
  growl;

  showGrowl = evt => {
    const message = evt.detail.message;
    if (message.clear) {
      this.growl.clear();
    }
    this.growl.show({
      severity: message.type,
      summary: message.summary,
      detail: message.content,
      closable: true,
      life: 5000
    });
  };

  componentDidMount() {
    this.props.eventBus.addEventListener("growl", this.showGrowl);
  }

  componentWillUnmount() {
    this.props.eventBus.removeEventListener("growl", this.showGrowl);
  }

  render() {
    return (
      <Growl
        ref={el => (this.growl = el)}
        position={this.props.position || "topright"}
        baseZIndex={50000}
      />
    );
  }
}
